/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $PlayerSearchElementList = {
    type: 'array',
    contains: {
        type: 'PlayerSearchElement',
    },
} as const;
